module.exports = __webpack_public_path__ + "static/media/instrucoes.9c982f59.svg";